export default __webpack_public_path__ + "static/media/princess.7b568beb.svg";